<template>
  <div class="all_services_section">
    <div class="cover_image_wrapper">
      <h2 class="cover_title">{{ $t('portal.Q_A') }}</h2>
      <img src="../../../assets/images/portal/cover-img.jpg" alt="" />
    </div>
    <div class="breadcrumb_wrapper">
      <b-container>
        <b-row>
          <b-col>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/portal/home">{{ $t('portal.home') }}</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">{{ $t('portal.Q_A') }}</li>
              </ol>
            </nav>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="menu_bar_wrapper">
      <b-container>
        <b-row class="menu_bar">
          <!-- <b-col sm="3" class="menubar_col ml-2">
            <div class="menu_left">
              <div class="form-group mb-0">
                <input type="tel" class="form-control" id="" placeholder="মোবাইল নম্বর" aria-describedby="mobile">
              </div>
            </div>
          </b-col> -->
          <b-col class="menubar_col">
            <div class="menu_right">
              <CommonSearch></CommonSearch>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="8">
            <div class="all_service_wrapper">
              <h5 class="service_title">{{ $t('portal.Q_A') + ` ` + $t('globalTrans.list') }}</h5>
                <div v-if="loading"><List/></div>
                <div v-else class="faq_wrapper" id="faqWrapper">
                  <div v-for="(faq, index) in faqList" :key="index" class="card">
                    <div class="card-header" id="q1">
                      <h2 class="que_wrapper">
                        <i class="far fa-question-circle"></i>
                        <button @click="(single_faq.answer === index) ? single_faq.answer ='' : single_faq.answer = index" class="btn btn-link btn-block text-left p-0" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          {{ checkBn ? faq.title_bn : faq.title }}
                        </button>
                      </h2>
                    </div>
                    <div id="collapseOne" v-if="single_faq.answer === index" class="collapse show" aria-labelledby="q1" data-parent="#faqWrapper">
                      <div class="card-body">
                        <span class="ans">{{ $t('portal.answer') }}- </span> {{ checkBn ? faq.description_bn : faq.description }}
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </b-col>
          <b-col sm="4">
            <div class="helpline_img">
              <img src="../../../assets/images/portal/help-line-bg.png" class="img-fluid" alt="" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import RestApi, { commonServiceBaseUrl } from '../../../config/api_config'
import Common from '@/mixins/portal/common'
import List from '../components/home/loading/faq/list'
import CommonSearch from '../components/CommonSearch'

export default {
  components: {
    List,
    CommonSearch
  },
  mixins: [Common],
  created () {
    this.loadData()
  },
  data () {
    return {
      loading: false,
      single_faq: {
        answer: 0
      },
      search: {
        title: ''
      }
    }
  },
  computed: {
    faqList () {
      return this.$store.state.Portal.faqList.filter(item => item.status === 1)
    }
  },
  methods: {
    searchData () {
      this.loadData()
    },
    async loadData () {
      this.loading = true
      const result = await RestApi.getData(commonServiceBaseUrl, '/portal/frontend/faq-list', this.search)
      this.loading = false
      if (result.success) {
        this.$store.dispatch('Portal/mutateFaqList', result.data)
      }
    }
  }
}
</script>
